import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./SupplierSidebar.css";

const SupplierSidebar = ({ open = false, onClose = () => {} }) => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleEscape = (event) => {
      if (event.key === "Escape") {
        onClose();
      }
    };

    document.addEventListener("keydown", handleEscape);

    return () => {
      document.removeEventListener("keydown", handleEscape);
    };
  }, [onClose]);

  const isActive = (path) => {
    if (path === "/supplier/dashboard") {
      return location.pathname === path;
    }

    return (
      location.pathname === path ||
      location.pathname.startsWith(`${path}/`)
    );
  };

  const goTo = (path) => {
    navigate(path);
    onClose();
  };

  return (
    <>
      <div
        className={`supplier-sidebar-overlay ${open ? "open" : ""}`}
        onClick={onClose}
        aria-hidden={!open}
      />

      <aside
        className={`supplier-sidebar ${open ? "open" : ""}`}
        aria-label="Supplier navigation"
      >
        <div className="supplier-sidebar-brand">
          <div className="supplier-brand-icon">
            <img
              src="/assets/logo.jpg"
              alt="Fleet Management Pro"
              className="supplier-brand-logo"
            />
          </div>

          <div className="supplier-brand-copy">
            <strong>Fleet Management Pro</strong>
            <span>SUPPLIER PORTAL</span>
          </div>

          <button
            type="button"
            className="supplier-sidebar-close"
            onClick={onClose}
            aria-label="Close navigation"
          >
            ×
          </button>
        </div>

        <nav className="supplier-sidebar-nav">
          <button
            type="button"
            className={`supplier-nav-item ${
              isActive("/supplier/dashboard") ? "active" : ""
            }`}
            onClick={() => goTo("/supplier/dashboard")}
          >
            <span className="supplier-nav-icon">⌂</span>
            <span className="supplier-nav-label">Dashboard</span>
          </button>

          <button
            type="button"
            className={`supplier-nav-item ${
              isActive("/supplier/vehicle-documents") ? "active" : ""
            }`}
            onClick={() => goTo("/supplier/vehicle-documents")}
          >
            <span className="supplier-nav-icon">▤</span>
            <span className="supplier-nav-label">
              Vehicle Documents
            </span>
          </button>

          <button
            type="button"
            className={`supplier-nav-item ${
              isActive("/supplier/statements") ? "active" : ""
            }`}
            onClick={() => goTo("/supplier/statements")}
          >
            <span className="supplier-nav-icon">▥</span>
            <span className="supplier-nav-label">
              Statements
            </span>
          </button>
        </nav>

        <div className="supplier-sidebar-footer">
          <span>Supplier Portal</span>
          <small>Fleet Management Pro</small>
        </div>
      </aside>
    </>
  );
};

export default SupplierSidebar;